import { getSeoConfig } from "./config";

export function slugify(input) {
  return String(input || "")
    .toLowerCase()
    .trim()
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 120);
}

export function normalizeSlugOrId(primary, fallbackId = "") {
  const first = String(primary || "").trim();
  if (first) return first;
  return String(fallbackId || "").trim();
}

export function resolveSlug(entity = {}, fieldCandidates = []) {
  const direct = String(entity.slug || "").trim();
  if (direct) return direct;

  for (const key of fieldCandidates) {
    const value = String(entity?.[key] || "").trim();
    if (!value) continue;
    const nextSlug = slugify(value);
    if (nextSlug) return nextSlug;
  }

  return "";
}

export function normalizePath(pathname) {
  if (!pathname) return "/";
  const next = String(pathname).trim();
  if (!next) return "/";
  return next.startsWith("/") ? next : `/${next}`;
}

export function absoluteUrl(pathname, config = getSeoConfig()) {
  const normalizedPath = normalizePath(pathname);
  return `${config.baseUrl}${normalizedPath}`;
}

export function buildEntityPath(routeKey, entity = {}) {
  switch (routeKey) {
    case "home":
      return "/";
    case "watch":
      return "/watch";
    case "series": {
      const slugOrId = normalizeSlugOrId(
        entity.slugOrId || resolveSlug(entity, ["title", "name"]),
        entity.id
      );
      return slugOrId ? `/series/${encodeURIComponent(slugOrId)}` : "/series";
    }
    case "video": {
      const slugOrId = normalizeSlugOrId(
        entity.slugOrId || resolveSlug(entity, ["title", "name"]),
        entity.id
      );
      return slugOrId ? `/video/${encodeURIComponent(slugOrId)}` : "/video";
    }
    case "profile": {
      const handle = String(entity.handle || entity.publicHandle || "")
        .trim()
        .replace(/^@+/, "");
      return handle ? `/u/${encodeURIComponent(handle)}` : "/u";
    }
    case "business": {
      const slugOrId = normalizeSlugOrId(
        entity.slugOrId ||
          resolveSlug(entity, ["displayName", "companyName", "name"]),
        entity.id
      );
      return slugOrId
        ? `/business/${encodeURIComponent(slugOrId)}`
        : "/business";
    }
    case "capsule": {
      const slugOrId = normalizeSlugOrId(
        entity.slugOrId ||
          resolveSlug(entity, ["title", "headline", "placeName", "seedName"]),
        entity.id
      );
      return slugOrId ? `/capsule/${encodeURIComponent(slugOrId)}` : "/capsule";
    }
    case "raffle": {
      const id = String(entity.id || entity.raffleId || entity.campaignId || entity.slugOrId || "").trim();
      return id ? `/raffles/c/${encodeURIComponent(id)}` : "/raffles";
    }
    default:
      return normalizePath(entity.path || "/");
  }
}

export function buildCanonicalUrl(routeKey, entity = {}, config = getSeoConfig()) {
  return absoluteUrl(buildEntityPath(routeKey, entity), config);
}
